const KEYBOARD_KEY_CODE = {
  ENTER: 13,
  ESCAPE: 27,
  BACKSPACE: 8
}

export {
  KEYBOARD_KEY_CODE
}
